module.exports = __webpack_public_path__ + "img/ewm2.795bf6c5.png";